import React, { useState } from 'react';
import { DELETE_ACCOUNT_WARNING } from '../constants';

interface DeleteAccountCardProps {
  onDelete: (password: string, reason?: string) => Promise<void>;
  loading?: boolean;
}

const DeleteAccountCard: React.FC<DeleteAccountCardProps> = ({ onDelete, loading = false }) => {
  const [showModal, setShowModal] = useState(false);
  const [password, setPassword] = useState('');

  const handleDelete = async () => {
    if (password.trim()) {
      try {
        await onDelete(password);
        setShowModal(false);
      } catch (error) {
        console.error('Delete error:', error);
      }
    }
  };

  return (
    <>
      <div className="rounded-2xl p-4 flex justify-between items-center">
        <div className="flex-1">
          <h3 style={{ fontFamily: 'Manrope', fontWeight: 600, fontSize: '16px', lineHeight: '22px', color: '#0B111E', marginBottom: '8px' }}>
            Delete Account
          </h3>
          <p style={{ fontFamily: 'Manrope', fontWeight: 400, fontSize: '12px', lineHeight: '16px', color: '#757575' }}>
            {DELETE_ACCOUNT_WARNING}
          </p>
        </div>
        <button
          onClick={() => setShowModal(true)}
          className="px-4 py-2 bg-[#DC0000] text-white rounded-lg hover:bg-[#c00000] transition-colors"
          style={{ fontFamily: 'Manrope', fontWeight: 500, fontSize: '14px', lineHeight: '22px' }}
        >
          Delete Account
        </button>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-6 max-w-md w-full">
            <h2 className="text-xl font-semibold mb-4">Confirm Account Deletion</h2>
            <p className="text-gray-600 mb-4">Please enter your password to confirm account deletion. This action cannot be undone.</p>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              className="w-full px-4 py-2 border rounded-lg mb-4"
              disabled={loading}
            />
            <div className="flex gap-3">
              <button
                onClick={handleDelete}
                disabled={loading || !password.trim()}
                className="flex-1 px-4 py-2 bg-[#DC0000] text-white rounded-lg hover:bg-[#c00000] disabled:opacity-50"
              >
                {loading ? 'Deleting...' : 'Delete'}
              </button>
              <button
                onClick={() => { setShowModal(false); setPassword(''); }}
                disabled={loading}
                className="flex-1 px-4 py-2 border rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeleteAccountCard;
